export default "__VITE_ASSET__CLqRnYyg__"